/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * PopulateEMR
 * OpenAPI spec version: v1
 */

export type InsuranceSlot = typeof InsuranceSlot[keyof typeof InsuranceSlot];


export const InsuranceSlot = {
  Primary: 'Primary',
  PrimaryDME: 'PrimaryDME',
  Secondary: 'Secondary',
  Tertiary: 'Tertiary',
  Other: 'Other',
} as const;
